/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Span } from 'libs/common-components/src';
import dayjs from 'dayjs';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { ManageActionMenu } from '@bvi/admin-panel/feature/manage-list/ui/manage-action-menu';
import { IManageBaseTableRowProperties } from './types';
import { styles } from './styles';

export const ManageBaseTableRow: FC<IManageBaseTableRowProperties & { tabValue: ManageBaseDataKeys }> = ({
  manageBase,
  tabValue,
  ...properties
}) => {
  const dateFormatted = dayjs(manageBase.createdAt).format('MM/DD/YYYY');

  return (
    <TableRow {...properties}>
      <TableCell>
        <Span sx={styles.tooltipContent}>{manageBase.id}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{manageBase.name}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{dateFormatted}</Span>
      </TableCell>
      <TableCell>
        <ManageActionMenu
          id={manageBase.id}
          detail={manageBase}
          type={tabValue}
        />
      </TableCell>
    </TableRow>
  );
};
